import styled from '@emotion/styled'
import { isMobile } from '@const/device'
import Title from '@organisms/Title'
import { getBrowserName } from '@utils/browser'

const DesktopFrame = styled.iframe<{ inModal: boolean; isLandscape: boolean }>`
  width: ${({ inModal }) => (inModal ? 'calc(100vw - 150px)' : '78vw')};
  height: ${({ inModal }) => (inModal ? '100vh' : '90%')};
  background: ${({ theme }) => theme.colors.background.surface};
  box-shadow: ${({ inModal }) =>
    inModal ? 'none' : '5px 5px 20px rgba(29, 78, 137, 0.1)'};
  border-radius: 15px;
  padding: 10px;
`
const MobileFrame = styled(DesktopFrame)<{
  inModal: boolean
  isLandscape: boolean
}>`
  height: ${({ inModal, isLandscape }) =>
    inModal ? (isLandscape ? '75vh' : '80vh') : '65vh'};
  width: ${({ inModal }) => (inModal ? '100vw' : '95vw')};
`
export const Frame = isMobile ? MobileFrame : DesktopFrame

const calculateHeight = (inModal: boolean, isLandscape: boolean) => {
  if (inModal) {
    if (isLandscape) {
      return 'calc(100vh - 40px)'
    }

    return 'calc(100vh - 100px)'
  }

  if (isMobile) {
    if (getBrowserName() === 'Safari') {
      if (isLandscape) {
        return '100vh'
      }

      return 'calc(100vh - 60px)'
    }

    return 'calc(100vh - 120px)'
  }

  return 'calc(100vh - 50px)'
}

const calculateHeightPropName = () => {
  if (isMobile) {
    return 'min-height'
  }

  return 'height'
}

export const Wrapper = styled.div<{ inModal: boolean; isLandscape: boolean }>`
  display: flex;
  flex-direction: column;
  background: ${({ inModal }) => (inModal ? 'white' : 'none')};
  gap: 10px;
  padding-bottom: ${({ inModal }) => (inModal ? '0' : '10px')};
  justify-content: ${() => (isMobile ? 'flex-end' : 'center')};

  ${({ inModal, isLandscape }) =>
    `${calculateHeightPropName()}: ${calculateHeight(inModal, isLandscape)};`}
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
`

export const NavButtonsWrapperDesktop = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`

export const NavButtonsWrapperMobile = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
`

export const NavButtonsWrapper = isMobile
  ? NavButtonsWrapperMobile
  : NavButtonsWrapperDesktop

export const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
`

export const TopWrapper = styled.div`
  width: 100%;
`

export const StyledTitle = styled(Title)`
  margin: 0 8px 8px;
  width: 100%;
  white-space: break-spaces;
  text-align: left;
`

export const MobileTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
`

export const MobileContentWrapper = styled.div<{ inModal: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`

export const BottomMobileContentWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;

  & > div {
    display: flex;
    border-radius: 32px;
    padding: 16px 24px;
    background-color: white;
  }
`

export const MobileNavBlockWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  & button {
    background-color: #f2f6fa;
  }
`

export const DesktopExpandInModalWrapper = styled.div`
  position: fixed;
  right: 20px;
  bottom: 50px;
`

export const MobileExpandInModalWrapper = styled.div`
  position: fixed;
  right: 20px;
  top: 20px;
`
